import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import api from "../../utils/api";
import { StringNumber, TMinisterio } from "../../types";
import { useQuery } from "@tanstack/react-query";



export const SelectMinisterio = ({ idsede, action, valor: _val }: { idsede: number | string, action: any, valor?: StringNumber | null | undefined }) => {


  const getMinisterio = async (): Promise<TMinisterio[] | []> => {
    try {
      const req = await api.get<TMinisterio[]>('ministerio/geral/sede/' + idsede);
      const res = req?.data;
      return res;
    } catch (error) {
      return []
    }
  }

  const { data: ministerios } = useQuery({
    queryKey: ['miniterio-select-list', idsede],
    queryFn: getMinisterio
  })

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Ministério</FormLabel>
        {
          ministerios && (
            <Select
            defaultValue={_val}
            value={_val}
            onChange={action}
          >
            {
              ministerios?.map(
                ministerio =>
                  <MenuItem value={ministerio?.id}>
                    {ministerio?.descricao}
                  </MenuItem>
              )
            }
          </Select>
          )
        }
      </Grid>
    </>
  )
}
